import { useEffect } from "react";

/**
 * Hook to detect clicks outside a ref element
 * @param {React.RefObject} ref - React ref to monitor
 * @param {Function} handler - Handler to call when click detected outside
 * @param {boolean} enabled - Whether the hook is enabled
 */
export const useOnClickOutside = (ref, handler, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    
    const listener = (e) => {
      const el = ref?.current;
      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains(e.target)) return;
      handler?.(e);
    };
    
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener, { passive: true });
    
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler, enabled]);
};
